import React, { Fragment } from 'react';
interface RitualIconProps {
  size?: number;
  className?: string;
  state?: 'default' | 'active' | 'completed';
}
export const RitualIcon: React.FC<RitualIconProps> = ({
  size = 20,
  className = '',
  state = 'default'
}) => {
  // Colors based on SinShift rarity system
  const commonGray = '#9CA3AF';
  const rareBlue = '#60A5FA';
  const epicPurple = '#A855F7';
  const legendaryGold = '#F59E0B';
  // Determine colors based on state
  const primaryColor = state === 'active' ? epicPurple : state === 'completed' ? legendaryGold : commonGray;
  const secondaryColor = state === 'active' ? rareBlue : state === 'completed' ? epicPurple : rareBlue;
  // Determine additional classes based on state
  const stateClasses = state === 'active' ? 'filter drop-shadow-[0_0_3px_rgba(168,85,247,0.5)]' : '';
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className} ${stateClasses}`} data-id="element-8633">
      {/* Outer Circle/Mandala */}
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-8634" />
      {/* Inner Circular Mandala with Gem Fragments */}
      <path d="M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6Z" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" fill="none" data-id="element-8635" />
      {/* Stylized Flame/Gem */}
      <path d="M12 7.5C11.3 8.6 10 10.5 10 12C10 13.5 11 15 12 15C13 15 14 13.5 14 12C14 10.5 12.7 8.6 12 7.5Z" fill={secondaryColor} stroke={primaryColor} strokeWidth="0.75" strokeLinecap="round" data-id="element-8636" />
      {/* Gem Fragments */}
      <path d="M9 10L10.5 11.5M14.5 11.5L16 10M9 14L10.5 12.5M14.5 12.5L16 14" stroke={primaryColor} strokeWidth="1" strokeLinecap="round" data-id="element-8637" />
      {/* Center Point */}
      <circle cx="12" cy="12" r="1" fill={primaryColor} data-id="element-8638" />
      {/* Completed State Checkmark */}
      {state === 'completed' && <path d="M16 9L11 14L8.5 11.5" stroke={legendaryGold} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-8639" />}
    </svg>;
};